import { makeStyles } from '@mui/styles'

const styles = makeStyles(theme => ({
  subTitle: {
    borderBottom: "1px solid " + theme.palette.divider,
    paddingBottom: theme.spacing(.5),
    marginBottom: theme.spacing(2),
    "& .MuiTypography-root": {
      color: theme.palette.text.primary
    }
  },
  hintMessage: {
    fontSize: theme.typography.fontSize,
    color: theme.palette.warning.dark,
    marginLeft: theme.spacing(1),
  },
}));
export default styles;
